export default class ProductUpdate {
	id: string;

	priceTypeForCalculation: string | null;

	packageSizeForSingleUnit: number | null;

	selected: boolean;

	constructor(
		id: string,
		priceTypeForCalculation: string | null,
		packageSizeForSingleUnit: number | null,
		selected: boolean
	) {
		this.id = id;
		this.priceTypeForCalculation = priceTypeForCalculation;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.selected = selected;
	}
}
